import {Component, Prop, Vue, Emit} from 'vue-property-decorator';
import Service from '../../../../common/src/assets/service/service';
import Common from '../../../../common/src/assets/js/common';
import Constant from '../../../../common/src/assets/constant/constant';
// @ts-ignore
import jsencrypt from '../../../../common/src/assets/encryption/jsencrypt/jsencrypt.min.js';
import LoginHeader from '../../components/login-header/login-header.vue';
import detection from '../../../../common/src/assets/js/detection';
import SlidingVerificationCode from '../../components/sliding-verification-code/sliding-verification-code.vue';
import LoginFooter from "../../components/login-footer/login-footer.vue";

declare var $: any;
@Component({
    components: {
        LoginHeader,
        LoginFooter,
        SlidingVerificationCode
    }
})
export default class ResetPassword extends Vue {
    private $router: any;
    private $layer: any
    private apiUrl: string = Service.apiPrefix;
    private toPath: string = '/general';

    private status: any = {
        email: '',
        password: '',
        confirmPassword: '',
        phone: '',
        vscode: '',
        loading: '',
        sign: '',
        countDown: 0,
        successDown: 0,
        haveEmail: false,
        havePhone: false,
    }
    private loading: any = {
        vscode: ''
    }
    private errorMsg: any = {
        email: '',
        password: '',
        confirmPassword: '',
        phone: '',
        vscode: '',
    }

    private component: any = {
        code: false,
    }

    created() {
        let token = Common.getCookie('ewalkToken');
        if (!token) {
            Service.createToken();
        }
    }
    mounted() {
    }


    /**检查输入框 */
    private checkInput(type: string, show: boolean = true) {
        let interfaceFlag = false;
        switch(type) {
            case 'email':
                if (this.status.email.trim() === '') {
                    this.errorMsg.email = "请输入邮箱";
                } else if (this.status.email.length > 50) {
                    this.errorMsg.email = "邮箱最大输入长度为50";
                } else if (!detection.email(this.status.email)) {
                    this.errorMsg.email = "请输入正确的邮箱格式";
                } else {
                    interfaceFlag = true;
                    let flag = this.checkRegistered('email', (res: any) => {
                        return res;
                    })
                }
                break;
            case 'password':
                this.errorMsg.password = this.status.password.trim() === '' ? '请输入新密码'
                                        : !detection.password(this.status.password) ? '密码格式错误(8-32字符)，至少包含（数字、字母、特殊字符）中的两种字符' : '';
                break;
            case 'confirmPassword':
                this.errorMsg.confirmPassword = this.status.confirmPassword.trim() === '' ? '请输入确认密码'
                                        : this.status.confirmPassword !== this.status.password ? '两次输入密码不一致' : '';
                break;
            case 'phone':
                if(this.status.phone.trim() === ''){
                    this.errorMsg.phone = "请输入手机号码";
                } else if (!detection.phone(this.status.phone)){
                    this.errorMsg.phone = "请输入正确的手机号码";
                } else {
                    interfaceFlag = true;
                    this.checkRegistered('phone', (res: any)=>{
                        return res;
                    })
                }
                break;
            case 'vscode':
                this.errorMsg.vscode = this.status.vscode.trim() === '' ? '请输入验证码'
                                        : !detection.captcha(this.status.vscode) ? '请输入正确的验证码格式' : '';
                break;
        }
        if(!interfaceFlag){
            return this.errorMsg[type] === '';
        }
    }


    /**提交 */
    private submit() {
        if (this.checkInput('vscode') === true) {
            this.errorMsg.vscode = '';
        }
        if (this.checkInput('phone') === false || this.checkInput('password') === false ||
            this.checkInput('confirmPassword') === false || this.checkInput('vscode') === false ||
            !this.status.havePhone || this.status.loading === 'loading') {
            return false;
        }
        /**加密账号密码 */
        let publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC3R2oMsiDws1jzuUxSfkaasNr/ZFsFER7Qn3ZC8uRwHgV+KQBMk//STuEvoYf0d+axg2T4xdJ/drjcIdQgGXn+xqYVfN88FYsHn3TTjoZ9/OS1nmVpnax/LIX77FwBghSC1YDHU9a006y71k1SnldtnW5FJ2uRM/KsdSOuIkPkFQIDAQAB';
        let encrypt = new jsencrypt();
        encrypt.setPublicKey(publicKey);
        let params = {
            password: encrypt.encrypt(this.status.password.trim()),
            phone: encrypt.encrypt(this.status.phone.trim()),
            code: this.status.vscode,
        }
        this.status.loading = 'loading';
        Service.request('/user/forgetPassword', params, 'token')
        .then((res: any) => {
            this.status.loading = 'havedata';
            this.successTips();
        })
        .catch(error => {
            this.status.loading = 'nodata';
            this.$layer.msg(error.errorMsg, {type: 'error'});
        });
    }

    /**成功提示 */
    private successTips() {
        this.status.successDown = Constant.skipTime;
        this.$layer.msg('修改成功 ! ' + this.status.successDown+ 's后, 自动跳转登录页面', {type: 'success', time: 1000});
        let delay = setInterval(() => {
            this.status.successDown--;
            if (this.status.successDown === 0) {
                clearInterval(delay);
                this.$router.push('/login');
                return;
            }
            this.$layer.msg('修改成功 ! ' + this.status.successDown+ 's后, 自动跳转登录页面', {type: 'success', time: 1000});
        }, 1000)
    }

    /**获取验证码 */
    private getVscode() {
        this.checkInput('phone')
        if (this.status.havePhone && this.errorMsg.phone === '') {
            this.component.code = true;
        }
    }

    /**滑块验证回调 */
    private vscodeChange($event: any, data: any) {
        this.loading.vscode = 'havedata';
        this.status.countDown = 60;
        let delay = setInterval(() => {
            this.status.countDown--;
            if (this.status.countDown === 1) {
                this.loading.vscode = '';
                clearInterval(delay);
            }
        }, 1000)
    }


    private skip(url: string) {
        this.$router.push(url);
    }

    /**检查邮箱/手机号是否已注册 */
    private checkRegistered(type: any, callback: any) {
        let params = {
            account: this.status[type]
        }
        Service.request('/common/checkUser', params, 'token').then(res => {
            if (type === 'email') {
                this.status.haveEmail = false;
                this.errorMsg[type] = '邮箱未注册';
            } else {
                this.status.havePhone = false;
                this.errorMsg[type] = '手机号码未注册';
            }
            callback(false)
        }).catch(error => {
            if (type === 'email') {
                this.status.haveEmail = true;
                this.errorMsg[type] = ''
            } else {
                this.status.havePhone = true;
                this.errorMsg[type] = ''
            }
            callback(true)
        });
    }
}
